import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { noop } from 'Helpers/PropTypes';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import {
  FDPaper,
  FDPrimaryActionButton,
  FDStack,
} from '@facet-wealth/design';

const styles = theme => ({
  root: {
    backgroundColor: theme.palette.common.white,
    borderRadius: theme.radius.md,
  },
  actionArea: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: theme.spacing(3),
    borderRadius: theme.radius.md,
  },
  rootMobile: {
    padding: theme.spacing(2),
  },
  priority: {
    marginRight: theme.spacing(1),
  },
  flexColumn: {
    flexDirection: 'column',
  },
  content: {
    display: 'flex',
    overflow: 'auto',
    flexGrow: 1,
  },
  name: {
    fontSize: theme.typography.fontSize1Rem,
    marginRight: theme.spacing(1),
  },
  nameMobile: {
    width: 'unset',
  },
  dueDate: {
    display: 'flex',
    flexDirection: 'row',
    marginRight: theme.spacing(1),
    fontSize: theme.typography.fontSize1Rem,
  },
  icon: {
    marginRight: theme.spacing(0.25),
    marginTop: theme.spacing(0.4),
  },
  dateText: {
    fontSize: 'inherit',
    lineHeight: 1.9,
    marginRight: theme.spacing(2),
  },
  description: {
    fontSize: theme.typography.fontSize1Rem,
    marginRight: theme.spacing(1),
  },
  button: {
    padding: theme.spacing(0.25, 1),
    zIndex: 99,
  },
});

const ActionItem = ({
  className,
  classes,
  name,
  status,
  actionTitle,
  onClick,
}) => {
  const completed = status === 'completed';

  return (
    <FDPaper width={'100%'} padding={400} className={classNames(classes.root, className)}>
      <FDStack direction={'column'} spacing={2} alignItems="flex-start" justifyContent="flex-start">
        <FDStack direction={'row'} alignItems={'center'} justifyContent="flex-start">
          <Text
            variant={'h3'}
            weight={'bold'}
            align={'left'}
            color={'textPrimary'}
            value={name}
            test="action-item-list-item"
          />
        </FDStack>
        <FDPrimaryActionButton isFullWidth label={completed ? 'Completed' : actionTitle} onClick={onClick} />
      </FDStack>
    </FDPaper>
  );
};

ActionItem.defaultProps = {
  className: '',
  onClick: noop,
};

ActionItem.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  actionTitle: PropTypes.string.isRequired,
  status: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
};

export default withStyles(styles)(ActionItem);
